import { getFunctionalPartitioningDictionary, getPurchaserCategoryDictionary } from '@/utils/api'

export default {
  state: {
    searchLightIndustryIdList: [], //主动筛选某一项照明字典的传参
    lightCategoryTypeList: [],
    lightCategoryTypeIdList: [],
  },
  getters: {},
  mutations: {
    setSearchLightIndustryIdList(state, data) {
      state.searchLightIndustryIdList = data
    },
    setLightCategoryTypeIdList(state, data) {
      state.lightCategoryTypeIdList = [...data]
    },
  },
  actions: {
    // 获取照明类别
    async getSearchLightIndustryIdList({ commit }) {
      let [err, res] = await getPurchaserCategoryDictionary(5)
      if (err) return
      commit('setSearchLightIndustryIdList', res)
    },
    async getLightCategoryTypeIdList({ commit }, id) {
      let [err, res] = await getFunctionalPartitioningDictionary(id)
      if (err) return
      commit('setLightCategoryTypeIdList', res)
    },
  }
}